import { render, staticRenderFns } from "./categories-action-columns.vue?vue&type=template&id=5e9fecf2"
import script from "./categories-action-columns.vue?vue&type=script&lang=js"
export * from "./categories-action-columns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports